module.exports = __webpack_public_path__ + "static/img/tab1.3ca556ac.png";